// Constants.js - Fixed version without process.env

module.exports = {
  // ✅ Production API URL (currently all environments use same URL)
  BASE_URL: "https://payoutapi.excro.in/api/v1/payout",

  // ✅ Uncomment below for local/staging environment
  // BASE_URL: "http://10.0.0.240:8085/api/payout",
  // BASE_URL: "http://10.0.0.204:8085/api/payout",

  SIGNUP_BASE_URL: "https://payoutapi.excro.in/api/v1/payout",

  // ✅ reCAPTCHA Site Key (same for all environments)
  SITE_KEY: "6LdaTLErAAAAADKE1gg2XB4AtxyhpMlzvFxZN1i2",

  // ✅ Disburse URL (same for all environments)
  DISBURSE_URL: "https://payoutdisburse.excro.in",

  // ✅ Tutelar Public Key
  PUBLIC_KEY: "tutpk_test_VvLpqsXfCQB7",

  // ✅ Account Configuration
  ACCOUNT_NUMBER_LENGTH: 20,
  DEFAULT_ACCOUNT_MID_NUMBER: "001",
};
